import { React, useState } from 'react';
import axios from 'axios';

import config from '../../../config/config.json';

import './HeaderAccount.scss';

function HeaderAccount(props) {

  const logoutHandler = () => {
    try {

      const baseurl = props.env.USE_LOCAL === "true" ? config.apiLocalHost : props.env.BASE_URL;

      return axios.get(
        baseurl +
        `v${props.env.API_VERSION}/${props.guid}/UserLogout?api-version=${props.env.API_VERSION}.0`
      );
    } catch (error) {
      console.log(error);
    } finally {      
      localStorage.removeItem('USER_AUTHENTICATED');
      localStorage.removeItem('SUBSCRIBER_DETAILS');
      localStorage.removeItem('GUID');
      localStorage.removeItem('PACKAGES');
      localStorage.removeItem('MONTHLY_DOWNLOAD_DATES');
      localStorage.removeItem('LAST_LOGIN');
      localStorage.removeItem('Subscriptions');      
      window.location.href = '/login'; 
    }
  };

  let toggleOn = <i className="fa fa-angle-up"></i>;
  let toggleOff = <i className="fa fa-angle-down"></i>;
  let dropdown = (
    <div className="account-menu-container">
      <ul className="account-menu-list" id="accountMenu">
        <li className="menu-option" id="myProfileOption">
          <a href="/myProfile">
            My Profile
          </a>
        </li>

        <li className="menu-option" id="helpAndFAQsOption">
          <a href={config.helpAndFAQsUrl} target="_blank" rel="noreferrer">
            Help and FAQs
          </a>
        </li>

        <li className="menu-option" id="logOutOption" onClick={logoutHandler}>
          <a href="/login">
            Log Out
          </a>
        </li>
      </ul>
    </div>
  );

  const [accountOpen, setAccountOpen] = useState(false);
  const [accountToggle, setAccountToggle] = useState(toggleOff);
  const [accountDropdown, setAccountDropdown] = useState('');

  const accountHandler = () => {
    if (!accountOpen) {
      setAccountOpen(true);
      setAccountToggle(toggleOn);
      setAccountDropdown(dropdown);
    } else {
      setAccountOpen(false);
      setAccountToggle(toggleOff);
      setAccountDropdown('');
    }
  };

  return (
    <div className="header-account-container">
      <div className="account-info-container">
        <div className="account-info">
          <div id="user-data">
            <div className="user-complete-name">
              {props.subscriberDetails.name}
            </div>
            <div className="user-email">{props.subscriberDetails.email}</div>
          </div>
          <div className="header-account-icon">
            <img
              id="headerAccountUserImage"
              alt="User Image Not Found"
              aria-hidden="true"
              src={config.bootstrapUrl_user}
            />
          </div>
          <div id="menu-arrow" onClick={accountHandler}>
            {accountToggle}
          </div>
        </div>
      </div>
      {accountDropdown}
    </div>
  );
}

export default HeaderAccount;
